import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import MainInput from "../../../component/atoms/input/mainInput";
import Radio from "../../../component/atoms/input/radio";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import LectureApi from "../../../api/lecture.api";

function LectureCategoryAdd() {
  // import
  const navigate = useNavigate();

  const [categoryData, setCategoryData] = useState({
    title: "",
    lectureCategoryType: "",
    activation: true,
  });

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveFunc = async () => {
    try {
      await LectureApi.addCategory(categoryData);
      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.create);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>추가하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={"true"}
                    name={"activation"}
                    valueText={"활성"}
                    checked={categoryData.activation}
                    onChange={() => {
                      setCategoryData({
                        ...categoryData,
                        activation: true,
                      });
                    }}
                  />
                  <Radio
                    id={"false"}
                    name={"activation"}
                    valueText={"비활성"}
                    checked={!categoryData.activation}
                    onChange={() => {
                      setCategoryData({
                        ...categoryData,
                        activation: false,
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>유형*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={"FINANCE_STUDY"}
                    name={"category"}
                    valueText={"금융 스터디"}
                    checked={
                      categoryData.lectureCategoryType === "FINANCE_STUDY"
                    }
                    onChange={() => {
                      setCategoryData({
                        ...categoryData,
                        lectureCategoryType: "FINANCE_STUDY",
                      });
                    }}
                  />
                  <Radio
                    id={"PAID_LECTURE"}
                    name={"category"}
                    valueText={"유료 강의"}
                    checked={
                      categoryData.lectureCategoryType === "PAID_LECTURE"
                    }
                    onChange={() => {
                      setCategoryData({
                        ...categoryData,
                        lectureCategoryType: "PAID_LECTURE",
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"카테고리명을 입력해주세요"}
                  value={categoryData.title}
                  onChange={(e) =>
                    setCategoryData({ ...categoryData, title: e.target.value })
                  }
                />
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  if (!categoryData.title.trim() || !categoryData.lectureCategoryType) {
                    return toast("유형과 제목을 모두 입력해주세요.");
                  }

                  setSaveModalOpen(true);
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
}

export default LectureCategoryAdd;
